import { render, staticRenderFns } from "./LoginAsTestatorOTP.vue?vue&type=template&id=ad5130aa"
import script from "./LoginAsTestatorOTP.vue?vue&type=script&lang=js"
export * from "./LoginAsTestatorOTP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports